import { createReducer, on } from '@ngrx/store';
import { initialPerformanceState } from '../../state/performance.state';
import { PerformanceActions } from '../action-types';
import * as SystemActions from './../../system/actions/system.actions';

export const performanceReducer = createReducer(
  initialPerformanceState,

  on(PerformanceActions.loadPerformanceData, (state, action) => {
    return {
      ...state,
      loading: true,
    };
  }),

  on(PerformanceActions.performanceDataLoaded, (state, action) => {
    return {
      ...state,
      performanceData: action.payload.performanceData,
      settings: {
        ...state.settings,
        toDate: action.payload.date,
        selectedEntities: [...action.payload.clientEntities],
      },
      selectedDate: action.payload.date,
      selectedEntities: [...action.payload.clientEntities],
      selectedPortfolios: action.payload.portfolios ? [...action.payload.portfolios] : [],
      retrieveData: false,
      loading: false,
      error: false,
      errorMessage: ''
    };
  }),

  on(PerformanceActions.loadAssetPerformanceData, (state, action) => {
    return {
      ...state,
      assetPerformanceDataLoading: true
    };
  }),

  on(PerformanceActions.loadAssetClassificationPerformanceData, (state, action) => {
    return {
      ...state,
      assetClassificationPerformanceDataLoading: true
    };
  }),

  on(PerformanceActions.assetPerformanceDataLoaded, (state, action) => {
    return {
      ...state,
      assetPerformanceData: action.payload.assetPerformanceData,
      settings: {
        ...state.settings,
        toDate: action.payload.date,
        selectedEntities: [...action.payload.clientEntities],
      },
      selectedDate: action.payload.date,
      selectedEntities: [...action.payload.clientEntities],
      selectedPortfolios: [...action.payload.portfolios],
      retrieveData: false,
      assetError: false,
      assetErrorMessage: '',
      assetPerformanceDataLoading: false
    };
  }),

  on(PerformanceActions.assetClassificationPerformanceDataLoaded, (state, action) => {
    return {
      ...state,
      assetClassificationPerformanceData: action.payload.assetPerformanceData,
      settings: {
        ...state.settings,
        toDate: action.payload.date,
        selectedEntities: [...action.payload.clientEntities],
      },
      selectedDate: action.payload.date,
      selectedEntities: [...action.payload.clientEntities],
      selectedPortfolios: [...action.payload.portfolios],
      retrieveData: false,
      assetClassificationError: false,
      assetClassificationErrorMessage: '',
      assetClassificationPerformanceDataLoading: false
    };
  }),

  on(PerformanceActions.updatePerformanceSettings, (state, action) => {
    return {
      ...state,
      settings: {
        ...state.settings,
        selectedReturnSpanMonths: action.settings.selectedReturnSpanMonths,
        selectedReturnPeriod: action.settings.selectedReturnPeriod,
        selectedReturnType: action.settings.selectedReturnType,
        selectedReturnSymbol: action.settings.selectedReturnSymbol,
      },
      retrieveData: true,
      loading: true,
    };
  }),

  on(PerformanceActions.updatePerformanceSettingsWithoutReload, (state, action) => {
    return {
      ...state,
      settings: {
        ...state.settings,
        selectedReturnSpanMonths: action.settings.selectedReturnSpanMonths,
        selectedReturnPeriod: action.settings.selectedReturnPeriod,
        selectedReturnType: action.settings.selectedReturnType,
        selectedReturnSymbol: action.settings.selectedReturnSymbol,
      }
    };
  }),

  on(PerformanceActions.clearPerformanceState, (state, action) => {
    return {
      ...state,
      settings: {
        ...state.settings,
        selectedReturnSpanMonths: action.settings.selectedReturnSpanMonths,
        selectedReturnPeriod: action.settings.selectedReturnPeriod,
        selectedReturnType: action.settings.selectedReturnType,
        selectedReturnSymbol: action.settings.selectedReturnSymbol,
      },
    };
  }),

  on(PerformanceActions.performanceDataError, (state, action) => {
    return {
      ...state,
      loading: false,
      error: true,
      errorMessage: action.errorMessage,
    };
  }),

  on(PerformanceActions.assetPerformanceDataError, (state, action) => {
    return {
      ...state,
      assetPerformanceDataLoading: false,
      assetError: true,
      assetErrorMessage: action.errorMessage,
    };
  }),

  on(PerformanceActions.assetClassificationPerformanceDataError, (state, action) => {
    return {
      ...state,
      assetClassificationPerformanceDataLoading: false,
      assetClassificationError: true,
      assetClassificationErrorMessage: action.errorMessage,
    };
  }),


  // Return to initial state when clear system action is called, i.e. on logout.
  on(SystemActions.ClearSystemStateAction, () => initialPerformanceState)
);
